import type { FC } from "react";
import { useEffect, useState } from "react";
import {
  type DeliverySchedules,
  useDeliverySchedulesRestApi,
} from "../../../hooks/useDeliverySchedulesRestApi";
import DeliverySchedulesPage from "./DeliverySchedulesPage";

const DeliverySchedulesPageContainer: FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { error, data } = useDeliverySchedulesRestApi({
    onCompleted: async () => {
      setIsLoading(false);
    },
  });

  const [deliverySchedules, setDeliverySchedules] = useState<DeliverySchedules>(
    {
      totalCount: 0,
      nodes: [],
    },
  );

  useEffect(() => {
    let isMounted = true;
    if (isMounted && data) {
      setDeliverySchedules(data.deliverySchedules);
    }
    return () => {
      isMounted = false;
    };
  }, [data]);

  if (error) {
    return <div>{JSON.stringify(error, null, 2)}</div>;
  }
  return (
    <DeliverySchedulesPage
      isLoading={isLoading}
      deliverySchedules={deliverySchedules}
    />
  );
};

export default DeliverySchedulesPageContainer;
